// The code in this file will load on every page of your site
import {session} from 'wix-storage';
import wixWindow from 'wix-window';
$w.onReady(function () {
  
  if(!session.getItem("firstTimePopupShown")) {
    wixWindow.openLightbox("Feedback");
    session.setItem("firstTimePopupShown", "yes");
    
  }
} );
